// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { PostOrPatchUserDto, ZitadelUser } from "@src/types/user-management";
import { buildRequestObjectForUser } from "@src/cloud-connect/user-manager/utils/build-request-user-object";

export const postCreateUser = async (
  namespace: string,
  user: Partial<ZitadelUser>,
) => {
  const url = userManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  const toBeCreatedUserObject: PostOrPatchUserDto =
    buildRequestObjectForUser(user);

  try {
    const response = await axios.post<ZitadelUser>(
      `${url}/api/v1/ns/${namespace}/users/human`,
      toBeCreatedUserObject,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      // Preserve the Axios response so the use case can parse structured 422 details.
      throw err;
    } else {
      throw new Error("An unexpected error occurred while creating user.");
    }
  }
};
